import { useMemo } from 'react';

import { useOpQuery } from 'utils/customHooks/useOpQuery';

export interface SupportedLanguageOption {
  code: string;
  name: string;
  nativeName: string;
}

const defaultSupportedLanguages: SupportedLanguageOption[] = [
  { code: 'en', name: 'English', nativeName: 'English' },
];

export const useSupportedLanguages = () => {
  const { data: fetchedLanguages = [] } = useOpQuery({
    apiEndpointName: 'globalListSupportedLanguages',
    parameters: [],
    suppressErrorMessage: true,
    select: (response) => response?.json?.data?.supportedLanguages || [],
  });

  const supportedLanguages = useMemo(() => {
    if (!fetchedLanguages.length) {
      return defaultSupportedLanguages;
    }

    return fetchedLanguages.reduce<SupportedLanguageOption[]>(
      (acc, language) => {
        if (!language.code) {
          return acc;
        }

        acc.push({
          code: language.code,
          name: language.nativeName || language.name || language.code,
          nativeName: language.nativeName || language.name || language.code,
        });

        return acc;
      },
      [],
    );
  }, [fetchedLanguages]);

  return supportedLanguages;
};
